import { render, staticRenderFns } from "./PanelPbyc.vue?vue&type=template&id=a43db852&scoped=true"
import script from "./PanelPbyc.vue?vue&type=script&lang=js"
export * from "./PanelPbyc.vue?vue&type=script&lang=js"
import style0 from "./PanelPbyc.vue?vue&type=style&index=0&id=a43db852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43db852",
  null
  
)

export default component.exports